<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { useProductGroupList } from '@/models/product-group'

  defineProps<{
    label?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const { productGroups, loading, getData } = useProductGroupList()
  getData()

  const selectedProductGroup = computed({
    set: (group?: string) => updateRoute({ group }),
    get: () => route.query.group as string | undefined,
  })
</script>

<template>
  <app-select
    v-model="selectedProductGroup"
    :label="label ?? 'Grup Produk'"
    :loading="loading">
    <option :value="undefined">
      Semua
    </option>
    <option
      v-for="group in productGroups"
      :key="group.id"
      :value="group.id">
      {{ group.name }}
    </option>
  </app-select>
</template>
